import React, {useEffect, useState} from 'react';
import {Button, Col, Flex, Form, Input, Popover, Select, Steps, StepsProps} from "antd";
import Header from "../../components/header/Header";
import BackGroundLogo from "../../components/adBackGroundLogo/BackGroundLogo";
import { GuaranteeCard} from "../../components";
import {useForm} from "antd/es/form/Form";
import {useLocation, useNavigate} from "react-router-dom";
import PriceCard from "../../components/priceCard/PriceCard";
import style from "./AInsertStepTow.module.scss"
import {connect} from "react-redux";
import {withRouter} from "../../../../utils/services/with-router";
import PropertiesCard from "../../components/propertiesCard/PropertiesCard";
import ConditionsCard from "../../components/conditionsCard/ConditionsCard";
import {registerProduct} from "../../actions/AdInsert.action";
import {AdInsertStepTwoProps} from "../../models";
import {StyledSteps} from "../AdInsertSteps.styled";

const AdInsertStepTwo = ({registerProduct}:AdInsertStepTwoProps) => {
    const [form] = useForm();
    const [price, setPrice] = useState()
    const [GuaranteeCards, setGuaranteeCard] = useState()
    const [PropertiesCards, setPropertiesCard] = useState()
    const [ConditionsCards, setConditionsCard] = useState()
    const onFinish = (value: any) => {
        value= location.state.stepOneForm
        value.ownerId= "7a36ceff-4848-4448-baf2-4d2a6c328a68"
        value.productAssurances =GuaranteeCards
        value.productConditions =ConditionsCards
        value.productProperties =PropertiesCards
        value.productPricings =price
        value.productImages =[]
        navigate('/ad-insert-step-three',{state:{
                stepTwoForm:value,stepOneForm:location.state.stepOneForm,uploadedImages:location.state.uploadedImages
            }})

    }
    const navigate = useNavigate();
    const location = useLocation();
    useEffect(() => {
        if (location.state?.stepTwoForm){
            setPrice(location.state?.stepTwoForm?.productPricings);
            setGuaranteeCard(location.state?.stepTwoForm?.productAssurances);
            setPropertiesCard(location.state?.stepTwoForm?.productProperties);
            setConditionsCard(location.state?.stepTwoForm?.productConditions);
        }
    }, [location]);
    const customDot: StepsProps['progressDot'] = (dot, { status, index }) => (
        <Popover

        >
            {dot}
        </Popover>
    );

    return (
        <Flex vertical gap={"small"}>
            <Header step={2}/>
            <BackGroundLogo step={2}/>
               <Flex vertical gap={"small"}>
                   <PriceCard onConfirm={(form:any) => {setPrice(form)}}/>
                   <GuaranteeCard  onConfirm={(form:any) => {setGuaranteeCard(form)}}/>
                   <PropertiesCard  onConfirm={(form:any) => {setPropertiesCard(form)}}/>
                   <ConditionsCard  onConfirm={(form:any) => {setConditionsCard(form)}}/>
                   <Form form={form} onFinish={onFinish}>
                       <Flex gap={"small"} className={style.customBtns}>
                           <Button  htmlType={"submit"} size={"large"} type={"primary"} block> ادامه</Button>
                           <Button onClick={() => navigate('/ad-insert-step-one',{state:{
                                   stepOneForm:location.state.stepOneForm,
                                   stepTwoForm:{
                                       productAssurances : GuaranteeCards,
                                       productConditions : ConditionsCards,
                                       productProperties : PropertiesCards,
                                       productPricings : price,
                                   }
                               }})} size={"large"}  block >مرحله قبل</Button>
                       </Flex>
                   </Form>
               </Flex>
        </Flex>
    );
};

export default connect(null, {registerProduct})(withRouter(AdInsertStepTwo));
